/**
 * @file
 * General JS additions to the Kinaxis theme.
 */
(function ($, Drupal) {
  // Globally available utilities.
  Drupal.utilityMenuMove = function () {
    var $utility_nav = $(
      '#block-utilitynavigation, #block-utilitynavigation--2'
    );
    $utility_nav.find('.menu--utility-navigation').show();
  };

  Drupal.getVidyard = function (el) {
    var video = $(el).find('.vidyard-player-embed');
    if (video) {
      var players = VidyardV4.api.getPlayersByUUID(video.attr('data-uuid'));
      for (player in players) {
        var player_container = players[player].container;
        if ($(el).has(player_container).length) {
          return [players[player]];
        }
      }
    }
    return [];
  };

  // Behaviors

  /**
   * Control location of the utility menu on resize.
   */
  Drupal.behaviors.kinaxisMenu = {
    attach: function (context, settings) {
      $(once('kinaxisMenu', 'header', context)).each(function () {
          // Move utility menu depending on viewport width
          Drupal.utilityMenuMove();
          $(window).resize(Drupal.utilityMenuMove);

          // Add class to top level menu items when flyout is being hovered over
          $('.ultimenu__flyout').hover(
            function () {
              // hover start
              $parent = $(this).parent();
              if (!$parent.hasClass('flyout-active')) {
                $parent.addClass('flyout-active');
              }
            },
            function () {
              $parent = $(this).parent();
              $parent.removeClass('flyout-active');
            }
          );
        });

      // Remove data-toggle from on-page menus so that top level items are clickable
      $(once('kinaxisSubmenu', 'article', context)).each(function () {
          $('article a[data-toggle="dropdown"]').removeAttr('data-toggle');
          $('article a .caret').click(function (e) {
            e.preventDefault();
            $(this).parent().dropdown('toggle');
          });
        });
    },
  };
  // fixes issue for ultimenu where the wide class does not apply
  Drupal.behaviors.addWideClass = {
    attach: function (context, settings) {
      $('.region-ultimenu-main-4c798a27, .region-ultimenu-main-822fc53d').addClass('wide');
    },
  };

  // fixes issue for ultimenu where the wide class does not apply
  Drupal.behaviors.animateInteger = {
    attach: function (context, settings) {
      const animateNumbers = document.querySelectorAll('.animate-number');

      const options = {
        root: null,
        rootMargin: '0px 0px 50px 0px', // Adjust margin as needed
        threshold: 0.5 // Start animation when 50% of the element is visible
      };

      const callback = (entries, observer) => {
        entries.forEach(entry => {
          const animateNumber = entry.target;
          if (entry.isIntersecting && !animateNumber.classList.contains('animated')) {
            animateNumber.classList.add('animated'); // Mark element as animated

            // split "." and get the last element.
            let dec = animateNumber.textContent.split('.')[1] ?? 0;
            const targetNumber = parseInt(animateNumber.textContent, 10);

            animateNumber.textContent = '0'; // Start from 0 for the counting effect

            const step = targetNumber / 100; // Adjust step size for desired counting speed
            let currentNumber = 0;

            if (dec) {
              // add the decimal back to the number
              let div = 10;
              if (dec > 9) {
                div = 100
              }
              dec = parseFloat(dec, 10) / div;
            }

            const intervalId = setInterval(() => {
              currentNumber += step;

              if (currentNumber >= targetNumber) {
                currentNumber = targetNumber;
                clearInterval(intervalId);
              }

              animateNumber.textContent = Math.floor(currentNumber) + dec;
            }, 10); // Adjust interval duration for desired counting speed
          }
        });
      };

      const observer = new IntersectionObserver(callback, options);

      animateNumbers.forEach(el => observer.observe(el));

    },
  };

  /**
   * Manually add wide class to ultimenu regions that sometimes lose it.
   */
  Drupal.behaviors.addWideClass = {
    attach: function (context, settings) {
      $('.region-ultimenu-main-4c798a27, .region-ultimenu-main-822fc53d').addClass('wide');
    },
  };

  /**
   * Modal open autoplay.
   */
  Drupal.behaviors.modalAutoplay = {
    attach: function (context, settings) {
      $(once('kinaxisModalAutoplay', '.video-modal')).each(function () {
          // First move the modal higher up in the DOM.
          $(this).detach().appendTo('body');

          // Then do the autoplay business.
          $(this).on('shown.bs.modal', function (e) {
            var players = Drupal.getVidyard(this);
            if (players.length) {
              if (!players[0].ready()) {
                players[0].on('ready', function () {
                  players[0].play();
                });
              } else {
                players[0].play();
              }
            }
          });
          $(this).on('hide.bs.modal', function (e) {
            var players = Drupal.getVidyard(this);
            if (players.length) {
              players[0].pause();
            }
          });
        });
    },
  };

  /**
   * Generic modal fix.
   */
  Drupal.behaviors.modalFix = {
    attach: function (context, settings) {
      $(once('kinaxisModalFix', '.content-modal')).each(function () {
          // Move the modal higher up in the DOM.
          $(this).detach().appendTo('body');
        });
    },
  };

  /**
   * Animated Underline
   * Ultimenu Navbar
   */
  Drupal.behaviors.underlineUltimenu = {
    attach: function (context, settings) {
      $(document).on(
        'mouseenter focus',
        '.block-ultimenu:has(.nav-underline) .ultimenu > li > a',
        function () {
          const $this = $(this);
          const $parent = $this.parent();
          const $container = $parent.parents('section');
          const $underline = $container.find('.nav-underline');

          const left = $parent.position().left;
          const width = $parent.outerWidth();

          $underline.css({ left: left, width: width });
        }
      );

      $(document).on(
        'mouseleave blur',
        '.block-ultimenu:has(.nav-underline) .ultimenu > li > a',
        function () {
          const $this = $(this);
          const $parent = $this.parent();
          const $container = $parent.parents('section');
          const $underline = $container.find('.nav-underline');

          $underline.css('width', '0px');
        }
      );
    },
  };
})(jQuery, Drupal);
